import { render, staticRenderFns } from "./videoMarkingDialog.vue?vue&type=template&id=15656823&scoped=true&"
import script from "./videoMarkingDialog.vue?vue&type=script&lang=js&"
export * from "./videoMarkingDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoMarkingDialog.vue?vue&type=style&index=0&id=15656823&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15656823",
  null
  
)

export default component.exports